export const templates: { [key: string]: { name: string; startDate: string; endDate: string }[] } = {
  "New Zealand universities": [
    /* 2024 dates */
    {
      name: "Full Academic Year, 2024",
      startDate: "2024-02-26",
      endDate: "2024-11-09",
    },
    {
      name: "Trimester 1, 2024",
      startDate: "2024-02-26",
      endDate: "2024-06-22",
    },
    {
      name: "Trimester 2, 2024",
      startDate: "2024-07-08",
      endDate: "2024-11-09",
    },
    {
      name: "Trimester 3, 2024",
      startDate: "2024-11-11",
      endDate: "2025-02-16",
    },
    /* 2025 dates */
    {
      name: "Full Academic Year, 2025",
      startDate: "2025-02-24",
      endDate: "2025-11-08",
    },
    {
      name: "Trimester 1, 2025",
      startDate: "2025-02-24",
      endDate: "2025-06-23",
    },
    {
      name: "Trimester 2, 2025",
      startDate: "2025-07-07",
      endDate: "2025-11-08",
    },
    {
      name: "Trimester 3, 2025",
      startDate: "2025-11-17",
      endDate: "2026-02-08",
    },
    /* 2026 dates */
    {
      name: "Full Academic Year, 2026",
      startDate: "2026-02-23",
      endDate: "2026-11-08",
    },
    {
      name: "Trimester 1, 2026",
      startDate: "2026-02-23",
      endDate: "2026-06-21",
    },
    {
      name: "Trimester 2, 2026",
      startDate: "2026-07-06",
      endDate: "2026-11-08",
    },
    {
      name: "Trimester 3, 2026",
      startDate: "2026-11-16",
      endDate: "2027-02-07",
    },
  ],
};
